<template>
  <div class="order-info">
    <div class="title">订单信息</div>
    <div class="order-info-wrapper" v-if="detail">
      <div class="number info-item">
        <span>订单号：</span>
        <span class="order-num">{{ detail.order_sn }}</span>
      </div>
      <div class="time info-item">
        <span>下单时间：</span>
        <span>{{ detail.created_at }}</span>
      </div>
      <div
        class="time info-item"
        v-if="detail.status == 5 || detail.status == 6"
      >
        <span>核销状态：</span>
        <span>{{ detail.status == 5 ? "未核销" : "已核销" }}</span>
      </div>
      <div v-if="payDetail.length">
        <div
          class="time info-item"
          v-for="(item, index) in payDetail"
          :key="index"
        >
          <span>{{ item.title }}：</span>
          <span>-￥{{ item.number }}</span>
        </div>
      </div>

      <div class="pay-price"
        ><span>实付：</span>￥{{ detail.actual_money }}</div
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object
    },
    payDetail: {
      type: Array
    }
  }
}
</script>

<style lang="less" scoped>
.order-info {
  background-color: #fff;
  border-radius: .08rem;
  color: #333333;
  margin-top: .2rem;
  .title {
    padding: .2rem;
    font-size: .34rem;
    font-weight: bold;
  }
  &-wrapper {
    padding: 0 .2rem .2rem;
    .info-item {
      .flex-between;
      padding-bottom: .2rem;
      font-size: .28rem;

      span:nth-child(2) {
        display: inline-block;
        max-width: 4.8rem;
        word-break: break-all;
      }
    }
  }
  .pay-price {
    display: flex;
    justify-content: flex-end;
    font-size: .32rem;
    color: #ff5151;
    padding-top: .1rem;
    padding-bottom: .25rem;
    span {
      font-size: .28rem;
      color: #000000;
      font-weight: bold;
    }
  }
}
</style>
